import type { ScenarioInsert } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { scenarioNodeSchema } from './scenarioNodeSchema'
import { z } from 'zod'

export const scenarioInsertSchema = z.object({
  name: z.string(),
  version_name: z.string().nullable().nullish(),
  nodes: z.array(z.lazy(() => scenarioNodeSchema)),
}) as unknown as ToZod<ScenarioInsert>

export type ScenarioInsertSchema = ScenarioInsert